// extracted by mini-css-extract-plugin
module.exports = {"hotelFacility":"HotelFacility_hotelFacility__3tfht","facilityTooltip":"HotelFacility_facilityTooltip__2BIb7"};